import React, { FC } from 'react'
import classnames from 'classnames/bind'
import CopyButton from '../copyButton'
import type { AutomationTarget } from '../../../types'
import styles from './styles.scss'

const cx = classnames.bind(styles)

export interface CopyableFieldProps extends AutomationTarget {
  label?: string
  value: string
  onCopy?: (text: string) => void
  className?: string
  showCopyButton?: 'always' | 'hover'
  buttonSize?: 'small' | 'medium' | 'large'
  disabled?: boolean
  ariaLabel?: string
}

export const CopyableField: FC<CopyableFieldProps> = ({
  label,
  value,
  onCopy,
  className,
  showCopyButton = 'hover',
  buttonSize = 'small',
  disabled = false,
  ariaLabel,
  elmId,
}) => {
  const effectiveAriaLabel = ariaLabel || `Copy ${label || 'value'}`

  return (
    <div
      className={cx(
        'copyable-field',
        `copyable-field--show-${showCopyButton}`,
        className
      )}
      data-elm-id={elmId}
    >
      {label && <span className={cx('copyable-field-label')}>{label}</span>}
      <div className={cx('copyable-field-value-wrapper')}>
        <span className={cx('copyable-field-value')}>{value}</span>
        <CopyButton
          text={value}
          onCopy={onCopy}
          size={buttonSize}
          variant='icon'
          disabled={disabled}
          ariaLabel={effectiveAriaLabel}
          className={cx('copyable-field-copy-button')}
        />
      </div>
    </div>
  )
}

export default CopyableField
